import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
//const app = require("https-localhost")()
// app is an express app, do what you usually do with express
//app.listen(port)

root.render(
  <GoogleOAuthProvider clientId="333456789055-ic8u7lm1uec4f3hodb6d82dbq4fo50ml.apps.googleusercontent.com">
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  </GoogleOAuthProvider>

);


